import { Component, Input } from '@angular/core';

@Component({
    selector: 'portal-icon-with-text',
    templateUrl: './icon-with-text.component.html',
    styleUrls: ['./icon-with-text.component.scss'],
    standalone: false
})
export class IconWithTextComponent {
  @Input() public iconName: string;
  @Input() public textToShow: string;
}
